{
    "ClientConfiguration_Table_Headers_Description": "Descrizione",
    "ClientConfiguration_Table_Headers_TelSys": "Server di telefonia",
    "ClientConfiguration_Table_Headers_Partition": "Partizione",
    "ClientConfiguration_Table_Headers_Device": "Dispositivo",
    "ClientConfiguration_Footer_Add": "Aggiungere",
    "ClientConfiguration_Footer_View": "Visualizzazione",
    "ClientConfiguration_Footer_Change": "Modifica",
    "ClientConfiguration_Footer_Delete": "Eliminare",
    "ClientConfiguration_Footer_Selected": "{} Selezionato",
    "ClientConfiguration_Footer_NoRows": "Non c'è niente da vedere qui...",
    "ClientConfiguration_No_Available_CMEs": "Non hai CME con le capacità richieste",
    "NAME": "ClientConfigurationLanguage",
    "ClientConfiguration_Table_Headers_CME": "Server di telefonia",
    "ClientConfiguration_Admin_Filters_CME": "ECM",
    "ClientConfiguration_Admin_Filters_IncludeChildCMEs": "Includere CME per bambini",
    "ClientConfiguration_Admin_Filters_Search": "Ricerca"
}